import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false,
  hover = false
}: CardProps) {
  return <div className={`bg-white border border-slate-200 rounded-lg shadow-sm ${hover ? 'hover:shadow-md hover:border-slate-300 transition-all duration-200' : ''} ${noPadding ? '' : 'p-6'} ${className}`} data-id="element-311">
      {children}
    </div>;
}